import React, { useEffect, useState } from "react";
import ImagerApi from "../../api/ImagerApi";
import SuiteApi from "../../api/SuiteApi";
import { ELightPath, ImagingCaptureProfile } from "../../Model/CaptureProfile";
import { LightPathCapability } from "../../Model/ImagerCapabilities";
import MtiButton from "../Buttons/MtiButton";
import "./ImagerFeatureControlLoader.css";
import ImagerFeatureControlLoaderPopUp from "./ImagerFeatureControlLoaderPopUp";
import { createPortal } from "react-dom";

type Props = {
  style?: React.CSSProperties;
  disabled?: boolean;
  lightPath: ELightPath;
  lightPathCapability: LightPathCapability;
  imagerIdentifier: string;
};

export default function ImagerFeatureControlLoader({
  style = {},
  disabled = false,
  lightPath,
  lightPathCapability,
  imagerIdentifier,
}: Props) {
  const [showPopUp, setShowPopUp] = useState(false);
  const [captureProfiles, setCaptureProfiles] = useState(
    [] as ImagingCaptureProfile[]
  );
  const [selectedCaptureProfilename, setSelectedCaptureProfileName] =
    useState("");

  const onClickLoadSettings = () => {
    SuiteApi.getCaptureProfiles(undefined, lightPath, imagerIdentifier).then(
      (captureProfiles: ImagingCaptureProfile[]) => {
        setCaptureProfiles(captureProfiles);
        setShowPopUp(true);
      }
    );
  };

  const setCaptureProfile = (cp: ImagingCaptureProfile) => {
    setSelectedCaptureProfileName(cp.name);
    ImagerApi.setCaptureProfile(imagerIdentifier, cp);
  };

  useEffect(() => {
    setSelectedCaptureProfileName("");
    setCaptureProfiles([]);
    SuiteApi.getCaptureProfiles(undefined, lightPath, imagerIdentifier).then(
      (captureProfiles: ImagingCaptureProfile[]) => {
        setCaptureProfiles(captureProfiles);
      }
    );
  }, [lightPath, imagerIdentifier]);

  const modalRoot = document.getElementById("modal-root") as HTMLElement;

  return (
    <div className="capture-profiles-loader">
      <label
        style={{
          flex: "1 0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Imaging Settings
      </label>
      <input
        value={selectedCaptureProfilename}
        disabled={true}
        style={{
          margin: "0px 20px 0px 10px",
          flex: "2 1 auto",
        }}
      />
      <MtiButton
        onClick={onClickLoadSettings}
        disabled={captureProfiles.length == 0}
        size="medium"
        style={{
          width: 128,
          fontSize: 12,
          minHeight: 28,
          letterSpacing: 1.25,
        }}
      >
        LOAD SETTINGS
      </MtiButton>
      {showPopUp &&
        createPortal(
          <ImagerFeatureControlLoaderPopUp
            // selectedCP={captureProfiles.length > 0 ? captureProfiles[0] : zeroCP}
            captureProfiles={captureProfiles}
            setCaptureProfile={setCaptureProfile}
            lightPathCapability={lightPathCapability}
            lightPath={lightPath}
            setShowPopUp={setShowPopUp}
            showPopUp={showPopUp}
          />,
          modalRoot
        )}
    </div>
  );
}
